import { Trash2 } from 'lucide-react';
import { getSquashSetWinnerScore, isValidSquashSetLoserScore } from './squashSetUtils';

function SquashScoreEditor({
  playerAId,
  playerAName,
  playerBId,
  playerBName,
  winnerId,
  loserScore,
  onWinnerChange,
  onLoserScoreChange,
  onRemove = null,
  disabled = false,
}) {
  const hasValidLoserScore = isValidSquashSetLoserScore(loserScore);
  const winnerScore = hasValidLoserScore ? getSquashSetWinnerScore(loserScore) : '';
  const playerAScore = winnerId === playerAId ? winnerScore : winnerId === playerBId ? loserScore : '';
  const playerBScore = winnerId === playerBId ? winnerScore : winnerId === playerAId ? loserScore : '';

  return (
    <div className="squash-score-editor">
      <div className="squash-winner-row">
        <span>Győztes</span>
        <button
          type="button"
          className={winnerId === playerAId ? 'active' : ''}
          onClick={() => onWinnerChange(playerAId)}
          disabled={disabled}
        >
          {playerAName}
        </button>
        <button
          type="button"
          className={winnerId === playerBId ? 'active' : ''}
          onClick={() => onWinnerChange(playerBId)}
          disabled={disabled}
        >
          {playerBName}
        </button>
        {onRemove && (
          <button
            type="button"
            className="button-soft squash-score-remove"
            onClick={onRemove}
            disabled={disabled}
            aria-label="Szett sor eltávolítása"
            title="Szett sor eltávolítása"
          >
            <Trash2 size={16} />
          </button>
        )}
      </div>

      <div className="squash-score-names" aria-hidden="true">
        <strong>{playerAName}</strong>
        <span>–</span>
        <strong>{playerBName}</strong>
      </div>

      <div className="squash-score-inputs">
        <input
          type="number"
          min="0"
          max="99"
          step="1"
          inputMode="numeric"
          value={playerAScore}
          onChange={(event) => {
            if (winnerId === playerBId) {
              onLoserScoreChange(event.target.value);
            }
          }}
          readOnly={winnerId !== playerBId}
          disabled={disabled || !winnerId}
          aria-label={`${playerAName} pontszáma`}
        />
        <span>–</span>
        <input
          type="number"
          min="0"
          max="99"
          step="1"
          inputMode="numeric"
          value={playerBScore}
          onChange={(event) => {
            if (winnerId === playerAId) {
              onLoserScoreChange(event.target.value);
            }
          }}
          readOnly={winnerId !== playerAId}
          disabled={disabled || !winnerId}
          aria-label={`${playerBName} pontszáma`}
        />
      </div>
    </div>
  );
}

export default SquashScoreEditor;
